<template>
    <v-dialog v-model="dialog" @keydown.esc="close()" persistent max-width="500px">
        <v-card>
            <v-card-title> </v-card-title>

            <v-card-text>
                <label class="file-select">
                    <div class="select-button">
                        <span v-if="file">File da importare : {{ file.name }}</span>
                        <span v-else>Seleziona File ...</span>
                    </div>
                    <input type="file" accept="*" @input="handleFileChange" />
                </label>
                <div>
                    <v-alert :value="true" type="info" outlined>
                        L'operazione sovrascriverà eventuali dati già presenti
                        L'importazione del file non può essere annullata. <br />
                    </v-alert>
                    <v-alert :value="!!alertElaborazione" :type="alertType" transition="scale-transition">
                        {{ alertElaborazione }}
                    </v-alert>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click.native="close()">Annulla</v-btn>
                <!-- :disabled="loading" -->

                <v-btn :loading="loading" :disabled="loading" text color="primary" @click.native="conferma">
                    Importa
                    <v-icon right dark>cloud_upload</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { upload_fileNews } from "@/api/api.home.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        idNews: { type: Number, default: null },
    },

    data: () => ({
        file: "",
        loading: false,
        alertElaborazione: "",
        alertType: "success",
    }),

    methods: {
        async conferma() {
            // Controllo presenza file
            if (this.file.length == 0) return;

            this.loading = true;

            let formData = new FormData();
            formData.append("file", this.file);

            let res = await upload_fileNews(formData, this.idNews);
            if (res.data == "OK") {
                this.alertElaborazione = "Elaborazione completata. File caricato";
                this.alertType = "success";
            } else {
                this.alertType = "error";
                if (res.data == "Error_Format") {
                    this.alertElaborazione =
                        "ERRORE: importazione del file fallita. Impossibile caricare il file, formato non valido";
                } else
                    this.alertElaborazione =
                        "ERRORE: importazione del file fallita. Riprovare";
            }
            this.loading = false;
        },

        close() {
            this.loading = false;
            this.file = "";
            this.alertElaborazione = "";
            this.$emit("chiudi");
        },

        handleFileChange(e) {
            // Whenever the file changes, emit the 'input' event with the file data.
            this.file = e.target.files[0];
        },
    },
};
</script>